import { createFileRoute } from "@tanstack/react-router";
import CardsManager from "@/pages/admin/CardsManager";

export const Route = createFileRoute("/admin/cards")({
  component: CardsManager,
});
